package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptomCharacteristic
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordSignSymptomCharacteristicDto: MedicalRecordSignSymptomCharacteristic() {
    var name:String?=null
    var description:String?=null
}